import React, { useState } from 'react';
import { Camera, Package, Award, Sparkles, Users, Clock } from 'lucide-react';

const VendorAmenities = ({ services = [], categories = [] }) => {
  const [showAll, setShowAll] = useState(false);

  const amenities = [];

  // Add service categories as amenities
  categories.forEach(category => {
    if (category?.category_name) {
      amenities.push({
        icon: Camera,
        label: category.category_name,
      });
    }
  });

  // Service count is shown in VendorKeyDetails, so we don't duplicate it here

  const visibleAmenities = showAll ? amenities : amenities.slice(0, 10);
  const hasMore = amenities.length > 10;

  if (amenities.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {visibleAmenities.map((amenity, index) => {
          const Icon = amenity.icon;
          return (
            <div key={index} className="flex items-center gap-3">
              <Icon className="w-5 h-5 text-black flex-shrink-0" />
              <span className="text-sm sm:text-base text-gray-700 font-light">
                {amenity.label}
              </span>
            </div>
          );
        })}
      </div>

      {hasMore && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="mt-4 text-sm font-medium text-black underline hover:no-underline transition-all"
        >
          {showAll ? 'Show less' : `Show all ${amenities.length} amenities`}
        </button>
      )}
    </div>
  );
};

export default VendorAmenities;

